<template>
    <Button :variant="variant" size="big" @click="handleAdd">
        {{ isCollection ? $t("stock-button-add-item") : $t("text-add-ad") }}
    </Button>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { useAuthStore } from '@stores/auth';
import { useSelectedStore } from '@stores/selected';
import Button from "@components/ui/button";

defineProps({
    variant: {
        type: String,
        default: 'accent'
    }
});

const { $eventBus } = useNuxtApp();

const auth = useAuthStore();
const store = useSelectedStore();
const route = useRoute();

// On "Moje sbírka" pages the header button adds a collection item instead of an ad.
const isCollection = computed(() => `${route.name || ''}`.startsWith('my-collection'));

const handleAdd = async () => {
    $eventBus.emit('sidebar:close');
    if (auth.isLoggedIn) {
        await navigatorTo(translatePath(isCollection.value ? ROUTES.CODE.STOCK_ADD : ROUTES.CODE.AD_ADD));
    } else {
        store.setAction('ADD_NEW_AD');
        $eventBus.emit('modal:open', 'LOGIN_VIEW');
    }
};

</script>
